import {
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { User } from '@digital-platform/users/domain';
import {
  WasteProfile,
  WasteProfileCard,
} from '@digital-platform/waste-profiles/domain';
import { WasteProfilesFacadeService } from '@digital-platform/waste-profiles/services';
import { CardsColumnEmptyDirective } from './cards-column-empty.directive';

@Component({
  selector: 'digital-platform-wp-cards-column',
  templateUrl: './cards-column.component.html',
  styleUrls: ['./cards-column.component.scss'],
})
export class CardsColumnComponent implements OnChanges {
  @HostBinding() class = 'digital-platform-wp-cards-column';

  @ContentChild(CardsColumnEmptyDirective)
  emptyContent!: CardsColumnEmptyDirective;

  @Input() public mode: 'ADMIN' | 'CUSTOMER' = 'CUSTOMER';
  @Input() public columnTitle = 'Waste Profiles';
  @Input() public expandable = true;
  @Input() public expanded = false;
  @Input() public loading = false;
  @Input() public user: User;
  @Input() public wasteProfiles: WasteProfileCard[] = [];

  @Output() public expand: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private wasteProfilesFacade: WasteProfilesFacadeService) {}

  ngOnChanges(): void {
    if (!this.columnTitle) {
      this.columnTitle = 'Waste Profiles';
    }
  }

  onExpand() {
    this.expanded = !this.expanded;
    this.expand.emit(this.expanded);
  }

  onDelete(wasteProfile: WasteProfile) {
    this.wasteProfilesFacade.delete(wasteProfile.id);
  }
}
